// SCN message model types - converted from Go backend models

import type { SCNMessageID } from '@/models/ids';
import type { RFC3339, Timestamps } from '@/models/base-types';

export const SCNMessageStatus = {
    WAITING: 'WAITING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
} as const;

export type SCNMessageStatus = typeof SCNMessageStatus[keyof typeof SCNMessageStatus];

export interface SCNMessage extends Timestamps {
    id: SCNMessageID;

    uid: string;        // Receiver UID for SCN
    token: string;      // Receiver Token for SCN (not shown in JSON response)
    channel: string;    // SCN channel
    senderName: string; // Sender name displayed in notification
    title: string;      // Title
    content: string;    // Content

    status: SCNMessageStatus;
    lastError: string | null;
    sentAt: RFC3339 | null;

    created: RFC3339;
    updated: RFC3339 | null;
    deleted: RFC3339 | null;
}

// List request/response types
export interface ListSCNMessagesOptions {
    status?: SCNMessageStatus;
    uid?: string;
    channel?: string;
    next?: string;
    limit?: number;
}

export interface ListSCNMessagesResponse {
    messages: SCNMessage[];
    next: string;
    total: number;
}

// Request bodies
export interface SendSCNMessageRequest {
    uid: string;
    token: string;
    channel: string;
    title: string;
    content: string;
}
